module.exports = __webpack_public_path__ + "img/close-2.1e0cda7b.svg";